var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-up-button"},[_c('div',{staticClass:"button-block",on:{"click":_vm.scrollToTop}},[_c('img',{attrs:{"src":require("@/assets/images/icons/arrow.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }